module.exports = __webpack_public_path__ + "img/Handball.9babaae7.png";